<template>
  <div class="row">
    <div class="col-md-12">
      <h2 class="text-white">Amazon Blocked Customer Management</h2>
    </div>
    <div class="col-md-12">
      <div class="row m-b-1">
        <div class="col-md-4">
          <h4 class="required">Customer Email Address</h4>
          <el-input v-model="form.customer_email"
                    type="text"
                    placeholder="Customer Email Address"/>
          <div v-if="!$v.form.customer_email.required" class="text-danger">
            Please enter customer's email address
          </div>
          <div v-if="!$v.form.customer_email.email" class="text-danger">
            Please enter a valid email address
          </div>
        </div>
        <div class="col-md-4">
          <h4>Phone</h4>
          <el-input v-model="form.customer_phone"
                    type="text"
                    placeholder="Customer Phone Number"/>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-4">
          <h4>First Name</h4>
          <el-input v-model="form.first_name"
                    type="text"
                    placeholder="Customer First Name"/>
        </div>
        <div class="col-md-4">
          <h4>Last Name</h4>
          <el-input v-model="form.last_name"
                    type="text"
                    placeholder="Customer Last Name"/>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-4">
          <h4>Delivery Country</h4>
          <el-autocomplete
              class="inline-input"
              v-model="form.delivery_address_country_code"
              :fetch-suggestions="countrySearch"
              placeholder="Delivery Country"
          ></el-autocomplete>
        </div>
        <div class="col-md-4">
          <h4>Delivery City</h4>
          <el-input v-model="form.delivery_address_city"
                    type="text"
                    placeholder="Delivery City"/>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-4">
          <h4>Delivery Street</h4>
          <el-input v-model="form.delivery_address_street"
                    type="text"
                    placeholder="Delivery Street"/>
        </div>
        <div class="col-md-4">
          <h4>Street Zipcode</h4>
          <el-input v-model="form.delivery_address_street_zipcode"
                    type="text"
                    placeholder="Delivery Street Zipcode"/>
        </div>
      </div>
      <div class="row m-t-2">
        <div class="col-md-8 text-right">
          <app-spinner v-if="isLoading"></app-spinner>
          <div v-else>
            <el-button
                type="primary"
                @click="resetForm"
            >
              Clear
            </el-button>
            <el-button
                :disabled="invalid"
                type="primary"
                @click="update"
            >
              Submit
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 m-t-2">
      <div style="margin: 15px 0;" class="text-right">
        <el-input placeholder="Search..." style="width: 20%" v-model="params.keyword" @keyup.enter.native="fetchList">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="isLoading"
          height="50vh"
      >
        <el-table-column
            fixed
            prop="customer_email"
            label="Email"
            width="350"
        >
        </el-table-column>
        <el-table-column
            prop="customer_phone"
            label="Phone"
            width="200">
        </el-table-column>
        <el-table-column
            prop="first_name"
            label="First Name"
            width="120">
        </el-table-column>
        <el-table-column
            prop="last_name"
            label="Last Name"
            width="120">
        </el-table-column>
        <el-table-column
            prop="delivery_address_country_code"
            label="Country"
            width="120">
        </el-table-column>
        <el-table-column
            prop="delivery_address_city"
            label="City"
            width="150">
        </el-table-column>
        <el-table-column
            prop="delivery_address_street"
            label="Street"
        >
        </el-table-column>
        <el-table-column
            prop="delivery_address_street_zipcode"
            label="Zipcode"
            width="120">
        </el-table-column>
        <el-table-column
            label="Actions"
            width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)">Edit</el-button>
            <el-button type="text" style="color: red" size="small" @click="handleDelete(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-size="20"
          layout="prev, pager, next"
          :total="params.total"
          style="text-align: right; padding: 5px 0;"
          :hide-on-single-page="false"
          @current-change="currentChangeHandler"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {required, email} from 'vuelidate/lib/validators';
import {validationMixin} from "vuelidate";
import AppSpinner from '../ui/AppSpinner';
import _ from 'lodash';
import axios from "../../repositories";
import {notify} from "../../utils";

export default {
  name: 'BlockedCustomer',
  mixins: [validationMixin],
  components: {
    AppSpinner,
  },
  data() {
    return {
      isLoading: false,
      form: {
        id: '',
        customer_email: '',
        customer_phone: '',
        first_name: '',
        last_name: '',
        delivery_address_country_code: '',
        delivery_address_city: '',
        delivery_address_street: '',
        delivery_address_street_zipcode: '',
      },
      tableData: [],
      params: {
        page: 1,
        total: 0,
        keyword: ''
      },
      countries: [],
    };
  },
  mounted() {
    this.fetchList();
    this.fetchCountries();
  },
  computed: {
    invalid: function () {
      return this.$v.$invalid;
    },
  },
  methods: {
    fetchList() {
      this.isLoading = true;
      axios.post('/kitsilano/blocked-customer/list', this.params).then(res => {
        const responseData = JSON.parse(res.data);
        this.params.total = responseData.data.total;
        this.tableData = responseData.data.data;
      }).catch(err => {
        notify(err, 'danger');
      }).finally(() => {
        this.isLoading = false;
      })
    },
    handleClick(row) {
      this.form = _.cloneDeep(row);
    },
    resetForm() {
      Object.keys(this.form).forEach(key => {
        this.form[key] = '';
      });
    },
    currentChangeHandler(page) {
      this.params.page = page
      this.fetchList()
    },
    update() {
      this.isLoading = true;
      axios.post('/kitsilano/blocked-customer/update', this.form).then(() => {
        notify('Customer info updated.', 'success');
        this.fetchList();
        this.resetForm();
      }).catch(err => {
        notify(err, 'danger');
      }).finally(() => {
        this.isLoading = false;
      })
    },
    handleDelete(row) {
      this.$confirm('Remove this blocked customer?', 'Notice', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true;
        axios.post(`/kitsilano/blocked-customer/delete`, {"id": row.id}).then(() => {
          notify('Customer info deleted.', 'success');
        }).catch(err => {
          notify(err, 'danger');
        }).finally(() => {
          this.fetchList();
          this.isLoading = false;
        })
      })
    },
    fetchCountries() {
      axios.get('/credit-dashboard/metadata/countries').then(res => {
        this.countries = res.data.map(item => ({value: item.label}));
      })
    },
    countrySearch(queryString, cb) {
      const countries = this.countries;
      const results = queryString ? countries.filter(this.createFilter(queryString)) : countries;
      cb(results);
    },
    createFilter(queryString) {
      return (countries) => {
        return (countries.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
  },
  validations() {
    return {
      form: {
        customer_email: {
          required,
          email,
        },
      },
    };
  },
};
</script>
<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>